import { generateItems } from 'domain/common';
import { Coupon } from 'domain/lib';

const { actions, selectors, reducer } = generateItems('Coupon', Coupon);

export { actions, selectors, reducer };
